import { proxy } from 'valtio';

export type TextToolTypes = 'text' | 'card';

export const defaultTextTool = 'text';

export const currentSelectedTextTool: Record<'selectedTextTool', TextToolTypes> = proxy({
  selectedTextTool: defaultTextTool,
});
